import {commitMutation, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'

import type {deleteIssueCommentMutation} from './__generated__/deleteIssueCommentMutation.graphql'

function updateTotalCount(store: RecordSourceSelectorProxy, connectionIds: string[]) {
  for (const connectionId of connectionIds) {
    const connection = store.get(connectionId)
    if (connection) {
      const previousCount = Number(connection.getValue('totalCount'))
      if (!isNaN(previousCount) && previousCount > 0) {
        connection.setValue(previousCount - 1, 'totalCount')
      }
    }
  }
}

export function commitDeleteIssueCommentMutation({
  environment,
  connectionIds,
  input: {id},
  onCompleted,
  onError,
}: {
  environment: Environment
  connectionIds: string[]
  input: {id: string}
  onCompleted?: () => void
  onError?: (error?: Error) => void
}) {
  return commitMutation<deleteIssueCommentMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation deleteIssueCommentMutation($connections: [ID!]!, $input: DeleteIssueCommentInput!) @raw_response_type {
        deleteIssueComment(input: $input) {
          clientMutationId
          issueComment {
            id @deleteEdge(connections: $connections)
          }
        }
      }
    `,
    variables: {
      input: {id},
      connections: connectionIds,
    },
    optimisticResponse: {
      deleteIssueComment: {
        clientMutationId: '',
        issueComment: {
          id,
        },
      },
    },
    optimisticUpdater: store => updateTotalCount(store, connectionIds),
    updater: store => updateTotalCount(store, connectionIds),
    onCompleted: response => {
      if (response.deleteIssueComment === null) {
        onError?.()
      } else {
        onCompleted?.()
      }
    },
    onError: error => onError?.(error),
  })
}
